<template>
  <div>
    <error-404 />
  </div>
</template>
<script>
import Error404 from "@/components/errors/404";
export default {
  components: {
    Error404
  }
};
</script>
